import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { CHANGE_PASSWORD, LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { loginSuccess, apiError, changePasswordSuccess } from "./actions"; //logoutUserSuccess

//Include Helper Files with needed methods
import {
  postSubmitFormNoAuth,
  postSubmitForm,
} from "../../../helpers/forms_helper";

import React from "react";
import { Redirect } from "react-router-dom";
// Users
import AddUser from "../../../pages/Users/AddUser";
import AllUsers from "../../../pages/Users/AllUsers";
import ChangePassword from "../../../pages/ChangePassword";

// Master Data
import AddBranches from "../../../pages/Branches/AddBranches";
import UpdateBranches from "../../../pages/Branches/UpdateBranches";
import BranchItems from "../../../pages/Branches/BranchItems";
import BranchProducts from "../../../pages/Branches/BranchProducts";

// Suupliers
import AddSupplier from "../../../pages/Suppliers/AddSupplier";
import UpdateSupplier from "../../../pages/Suppliers/UpdateSupplier";

import AddEquipmentsSupplier from "../../../pages/Equipments/Suppliers/AddEquipmentsSupplier";
import UpdateEquipmentsSupplier from "../../../pages/Equipments/Suppliers/UpdateEquipmentsSupplier";

// Items
import AddItem from "../../../pages/Items/AddItem";
import AddUnits from "../../../pages/Items/AddItemUnits";
import AllItems from "../../../pages/Items/AllItems";
import AddItemCategory from "../../../pages/Items/AddItemCategory";
import AllItemCategories from "../../../pages/Items/AllItemCategories";

// Products
import AddProduct from "../../../pages/Products/AddProduct";
import AllProducts from "../../../pages/Products/AllProducts";
import AddProductCategory from "../../../pages/Products/AddProductCategory";
import AllProductCategories from "../../../pages/Products/AllProductCategories";

// Dashboard
import Dashboard from "../../../pages/Dashboard/index";

// Orders
import FinishedProductAddOrder from "../../../pages/Orders/Branch/FinishedProducts/AddOrder";
import FinishedProductAllOrders from "../../../pages/Orders/Branch/FinishedProducts/AllOrders";

import ItemAddOrder from "../../../pages/Orders/Branch/Items/AddOrder";
import ItemAllOrders from "../../../pages/Orders/Branch/Items/AllOrders";

import FinishedProductNewOrders from "../../../pages/Orders/Centre/FinishedProducts/NewOrders";
import FinishedProductOrdersInProcess from "../../../pages/Orders/Centre/FinishedProducts/OrdersInProcess";
import FinishedProductOrdersInProcessForDashboard from "../../../pages/Orders/Centre/FinishedProducts/FinishedProductOrdersInProcessForDashboard";
import FinishedProductClosedOrders from "../../../pages/Orders/Centre/FinishedProducts/ClosedOrders";
import FinishedProductAllOrders_New from "../../../pages/Orders/Centre/FinishedProducts/AllOrders_New";

import ItemNewOrders from "../../../pages/Orders/Centre/Items/NewOrders";
import ItemOrdersInProcess from "../../../pages/Orders/Centre/Items/OrdersInProcess";
import ItemEditOrders from "../../../pages/Orders/Centre/Items/EditOrders";
import ItemClosedOrders from "../../../pages/Orders/Centre/Items/ClosedOrders";

// Equipment AllOrders. Store Manger 
import EquipmentNewOrders from "../../../pages/Orders/EquipmentStore/Equipments/NewOrders";
import EquipmentOrdersInProcess from "../../../pages/Orders/EquipmentStore/Equipments/OrdersInProcess";
import EquipmentAllOrders from "../../../pages/Orders/EquipmentStore/Equipments/AllOrders";
import EquipmentClosedOrders from "../../../pages/Orders/EquipmentStore/Equipments/ClosedOrders";

// Central Equipment order 
import AddEquipOrderByCentral from "../../../pages/Orders/Centre/Equipments/AddOrder"
import AllEquipOrderByCentral from "../../../pages/Orders/Centre/Equipments/AllOrders"

// Branch Equipment Order
import BranchEquipmentAddOrder from "../../../pages/Orders/Branch/Equipments/AddOrder"
import BranchEquipmentAllOrder from "../../../pages/Orders/Branch/Equipments/AllOrders"

// Main Store Equipment Order
import MainStoreEquipmentAddOrder from "../../../pages/Orders/MainStore/Equipments/AddOrder"
import MainStoreEquipmentAllOrder from "../../../pages/Orders/MainStore/Equipments/AllOrders"

// Sub Store Equipment Order
import SubStoreEquipmentAddOrder from "../../../pages/Orders/SubStore/Equipments/AddOrder"
import SubStoreEquipmentAllOrder from "../../../pages/Orders/SubStore/Equipments/AllOrders"

import InProcessOrderByBranch from "../../../pages/Orders/SubStore/Items/OrdersInProcess";
import DeficitOrder from "../../../pages/Orders/SubStore/Items/DeficitOrders";

// Inventory
import FinishedProductUpdateInventory from "../../../pages/Inventory/Centre/Products/UpdateInventory";
import FinishedProductViewInventory from "../../../pages/Inventory/Centre/Products/ViewInventory";
import FinishedProductTransferInventory from "../../../pages/Inventory/Centre/Products/Branch/TransferInventory";
import FinishedProductViewInventory_Branch_ByCentre from "../../../pages/Inventory/Centre/Products/Branch/ViewInventory";
import ItemUpdateInventory from "../../../pages/Inventory/Centre/Items/UpdateInventory";
import ItemViewInventory from "../../../pages/Inventory/Centre/Items/ViewInventory";
import ItemUsedInventory from "../../../pages/Inventory/Centre/Items/UsedInventory";
import ItemTransferInventory from "../../../pages/Inventory/Centre/Items/Branch/TransferInventory";
import ItemViewInventory_Branch_ByCentre from "../../../pages/Inventory/Centre/Items/Branch/ViewInventory";

import ItemViewInventory_Branch from "../../../pages/Inventory/Branch/Items/ViewInventory";
import ItemViewInventory_Branch_Kitchen from "../../../pages/Inventory/Branch/Items/ViewInventory_Kitchen";
import ItemViewInventory_Branch_Store from "../../../pages/Inventory/Branch/Items/ViewInventory_Store";
import ItemTransferInventory_Branch from "../../../pages/Inventory/Branch/Items/TransferInventory";
import ItemTransferInventory_ByBranch from "../../../pages/Inventory/Branch/Items/TransferInventoryByBranch";
import ItemViewInventory_AllBranches from "../../../pages/Inventory/Branch/Items/ViewInventoryAllBranches";
import ItemDiscardedInventory_Branch from "../../../pages/Inventory/Branch/Items/DiscardedInventory";
import ItemWastedInventory_Branch from "../../../pages/Inventory/Branch/Items/WastedInventory";
import ItemExpiredInventory_Branch from "../../../pages/Inventory/Branch/Items/ExpiredInventory";

import CentralEquipmentInventory from "../../../pages/Inventory/Centre/Equipments/ViewInventory"
import CentralKitchenEquipmentInventory from "../../../pages/Inventory/CentralKitchen/Equipments/ViewInventory"
import MainStoreEquipmentInventory from "../../../pages/Inventory/MainStore/Equipments/ViewInventory"
import SubStoreEquipmentInventory from "../../../pages/Inventory/SubStore/Equipments/ViewInventory"
import BranchEquipmentInventory from "../../../pages/Inventory/Branch/Equipments/ViewInventory"

import FinishedProductViewInventory_Branch from "../../../pages/Inventory/Branch/Products/ViewInventory";
import FinishedProductViewInventory_Branch_Kitchen from "../../../pages/Inventory/Branch/Products/ViewInventory_Kitchen";
import FinishedProductTransferInventory_Branch from "../../../pages/Inventory/Branch/Products/TransferInventory";
import FinishedProductTransferInventory_ByBranch from "../../../pages/Inventory/Branch/Products/TransferInventoryByBranch";
import FinishedProductViewInventory_AllBranches from "../../../pages/Inventory/Branch/Products/ViewInventoryAllBranches";
import FinishedProductDiscardedInventory_Branch from "../../../pages/Inventory/Branch/Products/DiscardedInventory";
import FinishedProductWastedInventory_Branch from "../../../pages/Inventory/Branch/Products/WastedInventory";
import FinishedProductExpiredInventory_Branch from "../../../pages/Inventory/Branch/Products/ExpiredInventory";

import EquipmentStoreViewInventory from "../../../pages/Inventory/EquipmentStore/ViewInventory";
import EquipmentStoreBranchInventory from "../../../pages/Inventory/EquipmentStore/ViewBranchInventory"
import UpdateEquipmentInventory from "../../../pages/Inventory/EquipmentStore/UpdateInventory"


// Procurement
import AddRequisition from "../../../pages/Procurement/AddRequisition";
import BranchRequisitionRequest from "../../../pages/Procurement/Branch/BranchRequisitionRequest";
import MainStorePORequestsCentre from "../../../pages/Procurement/Centre/MainStorePORequests";
import SubStorePORequestsCentre from "../../../pages/Procurement/Centre/SubStorePORequests";
import BranchWiseRequisition from "../../../pages/Procurement/Centre/BranchWiseRequisition";
import MainStoreWiseRequisition from "../../../pages/Procurement/Centre/MainStoreWiseRequisition";
import SubStoreWiseRequisition from "../../../pages/Procurement/Centre/SubStoreWiseRequisition";
import SupplierWiseRequisition from "../../../pages/Procurement/Centre/SupplierWiseRequisition";
import ViewPO from "../../../pages/Procurement/Centre/ViewPO";

import ViewPO_Owner from "../../../pages/Procurement/Centre/ViewPO_Owner";
import BranchPORequests from "../../../pages/Procurement/Centre/BranchPORequests";
import BranchPORequests_Branch from "../../../pages/Procurement/Branch/BranchPORequests";
import BranchAllPO from "../../../pages/Procurement/Branch/BranchAllPO";
import BranchPOGeneration from "../../../pages/Procurement/Centre/BranchPOGeneration";

import MainStorePORequests from "../../../pages/Procurement/Main Store/MainStorePORequests";
import SubStorePORequests from "../../../pages/Procurement/SubStore/SubStorePORequests";
import MainStoreRequisitionRequest from "../../../pages/Procurement/Main Store/MainStoreRequisitionRequest";
import SubStoreRequisitionRequest from "../../../pages/Procurement/SubStore/SubStoreRequisitionRequest";
import MainStoreAllPO from "../../../pages/Procurement/Main Store/MainStoreAllPO";

//Closing
import BranchFinishedProductClosing from "../../../pages/BranchClosing/Products/Closing";
import BranchItemClosing from "../../../pages/BranchClosing/Items/Closing";

//Setting
import AppSettings from "../../../pages/Settings/AppSettings";

//Notifications
import Notifications from "../../../pages/Notifications";

// Reports

import BranchwiseSummaryReport from "../../../pages/Reports/Centre/BranchwiseSummaryReport";
import UserBasedTransactionReport from "../../../pages/Reports/Centre/UserBasedTransactionReport";
import ItemsPOCostingReport from "../../../pages/Reports/Centre/Items/ItemsPOCostingReport";
import ItemsPOCostDifferenceReport from "../../../pages/Reports/Centre/Items/ItemsPOCostDifferenceReport";
import ItemArrangementReport from "../../../pages/Reports/Centre/Items/ItemArrangementReport";
import ProductArrangementReport from "../../../pages/Reports/Centre/Products/ProductArrangementReport";
import ProductOrderReport from "../../../pages/Reports/Centre/Products/ProductOrderReport";
import BranchwiseProductOrderReport from "../../../pages/Reports/Centre/Products/BranchwiseProductOrderReport";
import ProductwiseOrderReport from "../../../pages/Reports/Centre/Products/ProductwiseOrderReport";
import ProductSectionwiseOrderReport from "../../../pages/Reports/Centre/Products/ProductSectionwiseOrderReport";
import ItemOrderReport from "../../../pages/Reports/Centre/Items/ItemOrderReport";
import BranchwiseItemOrderReport from "../../../pages/Reports/Centre/Items/BranchwiseItemOrderReport";
import ItemwiseOrderReport from "../../../pages/Reports/Centre/Items/ItemwiseOrderReport";
import ItemCategorywiseOrderReport from "../../../pages/Reports/Centre/Items/ItemCategorywiseOrderReport";

import BranchwiseProductUsedInventoriesCostReport from "../../../pages/Reports/Centre/Products/BranchwiseProductUsedInventoriesCostReport";
import BranchwiseItemUsedInventoriesCostReport from "../../../pages/Reports/Centre/Items/BranchwiseItemUsedInventoriesCostReport";
import BranchwiseProductBalanceInventoriesReport from "../../../pages/Reports/Centre/Products/BranchwiseProductBalanceInventoriesReport";
import BranchwiseItemBalanceInventoriesReport from "../../../pages/Reports/Centre/Items/BranchwiseItemBalanceInventoriesReport";
import BranchwiseProductExpiringInventoriesReport from "../../../pages/Reports/Centre/Products/BranchwiseProductExpiringInventoriesReport";
import BranchwiseItemExpiringInventoriesReport from "../../../pages/Reports/Centre/Items/BranchwiseItemExpiringInventoriesReport";
import BranchwiseProductDiscardedInventoriesReport from "../../../pages/Reports/Centre/Products/BranchwiseProductDiscardedInventoriesReport";
import BranchwiseItemDiscardedInventoriesReport from "../../../pages/Reports/Centre/Items/BranchwiseItemDiscardedInventoriesReport";
import BranchwiseProductWastedInventoriesReport from "../../../pages/Reports/Centre/Products/BranchwiseProductWastedInventoriesReport";
import BranchwiseItemWastedInventoriesReport from "../../../pages/Reports/Centre/Items/BranchwiseItemWastedInventoriesReport";
import ProductDeficiencyReport from "../../../pages/Reports/Centre/Products/ProductDeficiencyReport";
import ItemDeficiencyReport from "../../../pages/Reports/Centre/Items/ItemDeficiencyReport";
import HighlyUsedProductReport from "../../../pages/Reports/Centre/Products/HighlyUsedProductReport";
import HighlyUsedItemReport from "../../../pages/Reports/Centre/Items/HighlyUsedItemReport";
import HighlyOrderedProductReport from "../../../pages/Reports/Centre/Products/HighlyOrderedProductReport";
import HighlyOrderedItemReport from "../../../pages/Reports/Centre/Items/HighlyOrderedItemReport";
import PartialDeliveryFromCentralKitchenReport from "../../../pages/Reports/Centre/Products/PartialDeliveryFromCentralKitchenReport";
import PartialDeliveryFromCentralStoreReport from "../../../pages/Reports/Centre/Items/PartialDeliveryFromCentralStoreReport";
import PartialDeliveryFromSupplierReport from "../../../pages/Reports/Centre/Items/PartialDeliveryFromSupplierReport";
import SupplierMonthlyReport from "../../../pages/Reports/Centre/Items/SupplierMonthlyReport";
import SupplierReturnReport from "../../../pages/Reports/Centre/Items/SupplierReturnReport";
import ItemCostTrendReport from "../../../pages/Reports/Centre/Items/ItemCostTrendReport";
// import CostOfGoodsSoldReport from "../../../pages/Reports/Centre/CostOfGoodsSoldReport";
import CostOfGoodsSoldProductsReport from "../../../pages/Reports/Centre/Products/CostOfGoodsSoldProductsReport";
import CostOfGoodsSoldItemsReport from "../../../pages/Reports/Centre/Items/CostOfGoodsSoldItemsReport";
import BranchItemTransferReport from "../../../pages/Reports/Centre/Items/BranchItemTransferReport";
import BranchProductTransferReport from "../../../pages/Reports/Centre/Products/BranchProductTransferReport";
// Main Store Items
import AllItemRequestsMain from "../../../pages/Transfer/MainStore/Items/AllItemRequests";
import AddNewItemOrderMain from "../../../pages/Orders/MainStore/Items/AddOrder";
import AllItemOrdersMain from "../../../pages/Orders/MainStore/Items/AllOrders";
import DirectItemTransferMain from "../../../pages/Transfer/MainStore/Items/DirectTransfer";
import AllItemDirectTransfers from "../../../components/Transfers/Items/AllDirectTransfers";

// Sub Store Items
import AllItemRequestToSubStore from "../../../pages/Transfer/SubStore/Items/AllItemRequests";
import DirectTransferFromSubStore from "../../../pages/Transfer/SubStore/Items/DirectTransfer";
import AddNewItemOrderSubStore from "../../../pages/Orders/SubStore/Items/AddNewOrder";
import AllItemsOrdersSubStore from "../../../pages/Orders/SubStore/Items/AllItemsOrders";

// Branch Orders to Sub Store
import BranchItemAddOrdersToSubStore from "../../../pages/Transfer/Branch/Items/AddNewOrder"
import BranchItemAllOrdersToSubStore from "../../../pages/Transfer/Branch/Items/AllItemsOrders"

// Central Store Items
import AllItemOrder from "../../../pages/Transfer/CentralStore/AllItemOrder";
import ItemsDirectTransferFromCentral from "../../../pages/Transfer/CentralStore/ItemsDirectTransfer";
import CentreAllItemRequest from "../../../pages/Transfer/CentralStore/AllItemRequests";
import AddNewItemOrderFromCentral from "../../../pages/Transfer/CentralStore/AddNewItemOrder";

// Store Item Inventories
import MainStoreItemInventory from "../../../pages/Inventory/MainStore/Items/ViewInventory";
import SubStoreItemInventory from "../../../pages/Inventory/SubStore/Items/ViewInventory";

import MainStoreItems from "../../../pages/MainStore/MainStoreItems";
import MainStotorePOGeneration from "../../../pages/Procurement/Centre/MainStotorePOGeneration";
import SubStotorePOGeneration from "../../../pages/Procurement/Centre/SubStorePOGeneration";

// Equipments
import AddEquipment from "../../../pages/Equipments/Equipments/AddEquipment";
import UpdateEquipments from "../../../pages/Equipments/Equipments/UpdateEquipments";
import AddStore from "../../../pages/Stores/AddStore";
import AllStore from "../../../pages/Stores/AllStore";
import SubStoreAllPO from "../../../pages/Procurement/SubStore/SubStoreAllPO";
import AddItemUnits from "../../../pages/Items/AddItemUnits";
import AddProductUnits from "../../../pages/Products/AddProductUnits";
import BranchItemsReturn from "../../../pages/Return/Branch/AddReturn";
import BranchItemAllReturn from "../../../pages/Return/Branch/AllReturn";
import SubStoreItemReturn from "../../../pages/Return/SubStore/AddReturn";
import SubStoreItemAllReturn from "../../../pages/Return/SubStore/AllReturn";
import CentralStoreItemReturn from "../../../pages/Return/CentralStore/AddReturn";
import CentralStoreItemAllReturn from "../../../pages/Return/CentralStore/AllReturn";
import FPUrgentOrders from "../../../pages/Orders/Centre/FinishedProducts/UrgentOrders";
import AllDrafts from "../../../pages/Orders/Branch/Items/AllDrafts";
import FinishedProductsDirectTransfer from "../../../pages/Transfer/CentralStore/FPDirectTransfer";
import AllFPDirectTransfers from "../../../components/Transfers/Products/AllDirectTransfers";
import showNotification from "../../../helpers/show_notification";
import AddLocation from "../../../pages/Location/AddLocation";
import AllLocations from "../../../pages/Location/AllLocations";
import AddVehicle from "../../../pages/Vehicle/AddVehicle";
import AllVehicle from "../../../pages/Vehicle/AllVehicle";
import ItemLocDriverArrangementReport from "../../../pages/Reports/Centre/Items/ItemLocDriverArrangementReport";
import ProductCategoryDriverArrangementReport from "../../../pages/Reports/Centre/Products/ProductCategoryDriverArrangementReport";
import SupplierChangeReport from "../../../pages/Reports/Centre/Items/SupplierChangeReport";
import ItemReplacementReport from "../../../pages/Reports/Centre/Items/ItemReplacementReport";
import ItemOrderCorrection from "../../../pages/Orders/ItemOrderCorrection";
import FPOrderCorrection from "../../../pages/Orders/FPOrderCorrection";
import ItemWithdrawlCorrection from "../../../pages/Inventory/ItemWithdrawlCorrection";
import POCorrection from "../../../pages/Procurement/POCorrection";
import FPWithdrawlCorrection from "../../../pages/Inventory/FPWithdrawlCorrection";
import CreateDraftPO from "../../../pages/Procurement/Draft/CreateDraftPO";
import CentraStoreWastedInventory from "../../../pages/Inventory/Centre/Items/WastedInventory"
import CentraKitchenFPWastedInventory from "../../../pages/Inventory/Centre/Products/WastedInventory"
import ItemsMapToAll from "../../../pages/Branches/ItemsMapToAll";
import ProductsMapToAll from "../../../pages/Branches/ProductsMapToAll";
import CorrectionReport from "../../../pages/Reports/Centre/CorrectionReport";
import BranchwiseItemUsedInventoriesReport from "../../../pages/Reports/Centre/Items/BranchwiseItemUsedInventoriesReport";
import BranchwiseProductUsedInventoriesReport from "../../../pages/Reports/Centre/Products/BranchwiseProductUsedInventoriesReport";
import FreeGoodsReport from "../../../pages/Reports/Centre/Items/FreeGoodsReport";
import DebugPage from "../../../pages/Debug/DebugPage";
import COGSDebug from "../../../pages/Debug/COGSDebug";
import AllEquipCategories from "../../../pages/Equipments/Equipments/AllEquipCategories";
import AddEquipCategory from "../../../pages/Equipments/Equipments/AddEquipCategory";
import AddEquipmentUnits from "../../../pages/Equipments/Equipments/AddEquipmentUnits";
import FoodConsumptionReports from "../../../pages/Reports/Centre/Items/SupplierFoodConsumptionReport";
import FoodCostAndTargetAchievementReport from "../../../pages/Reports/Centre/Items/FoodCostAndTargetAchievementReport";
import BranchCategory from "../../../pages/BranchCategory/BranchCategory";
import FinishedProductPOGeneration from "../../../pages/Procurement/Centre/FinishedProduct/FinishedProductPOGeneration";
import FinishedProductViewPO from "../../../pages/Procurement/Centre/FinishedProduct/FinishedProductViewPO";
import ProductsPOCostingReport from "../../../pages/Reports/Centre/Products/ProductsPOCostingReport";
import ProductsPOCostDifferenceReport from "../../../pages/Reports/Centre/Products/ProductsPOCostDifferenceReport";
import COGSItemsDateRangeReport from "../../../pages/Reports/Centre/Items/COGSItemsDateRangeReport";
import COGSProductsDateRangeReport from "../../../pages/Reports/Centre/Products/COGSProductsDateRangeReport";
import ItemWiseUsedTotalReport from "../../../pages/Reports/Centre/Items/ItemWiseUsedTotalReport";


function* loginUser({ payload: { user, history } }) {
  try {
    let url = process.env.REACT_APP_BASEURL + "adminusers/login";

    const response = yield call(postSubmitFormNoAuth, url, user);

    if (response.status === 1) {
      let routes = [];
      const role = response.data.role;
      const store_type = response.data.branch_details.type;
      if (role == "Branch Supervisor") {
        const is_store = response.data.branch_details.is_store;
      }

      if (role == "admin" || role == "Owner") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/debug", component: DebugPage },
          { path: "/cogs_debug", component: COGSDebug },
          { path: "/app_settings", component: AppSettings },
          { path: "/item_order_correction", component: ItemOrderCorrection},
          { path: "/finished_poduct_order_correction", component: FPOrderCorrection},
          { path: "/item_withdrawl_correction", component: ItemWithdrawlCorrection},
          { path: "/correction_report", component: CorrectionReport},
          { path: "/finished_product_withdrawl_correction", component: FPWithdrawlCorrection},
          { path: "/purchase_order_correction", component: POCorrection},
          { path: "/add_location", component: AddLocation },
          { path: "/all_locations", component: AllLocations },
          { path: "/add_vehicle", component: AddVehicle },
          { path: "/all_vehicles", component: AllVehicle },
          { path: "/centralstore/items/return", component: CentralStoreItemReturn},
          { path: "/centralstore/items/allreturn", component: CentralStoreItemAllReturn},      
          { path: "/notifications", component: Notifications },
          { path: "/items/alltransfers", component: AllItemDirectTransfers },
          { path: "/finished_products/alltransfers", component: AllFPDirectTransfers },
          { path: "/equipments/centralkitchen/inventory", component: CentralKitchenEquipmentInventory },
          { path: "/finished_products/transfer_inventory_by_branch", component: FinishedProductTransferInventory_ByBranch},
          { path: "/finished_products/transfer_inventory", component: FinishedProductTransferInventory},
          { path: "/finished_products/view_all_branch_inventory", component: FinishedProductViewInventory_AllBranches},
          { path: "/items/transfer_inventory_by_branch", component: ItemTransferInventory_ByBranch},
          { path: "/items/transfer_inventory", component: ItemTransferInventory},
          { path: "/items/view_all_branch_inventory", component: ItemViewInventory_AllBranches},
          { path: "/finished_products/view_branch_inventory", component: FinishedProductViewInventory_Branch},
          { path: "/finished_products/view_branch_inventory_kitchen", component: FinishedProductViewInventory_Branch_Kitchen},
          { path: "/finished_products/expired_inventory", component: FinishedProductExpiredInventory_Branch},
          //Reports
          { path: "/branchwise_summary_report", component: BranchwiseSummaryReport},
          { path: "/items/supplier_food_consumption_report", component: FoodConsumptionReports },
          { path: "/items/branch_target_achievement_report", component: FoodCostAndTargetAchievementReport },
          { path: "/free_goods_report", component: FreeGoodsReport},
          
          {
            path: "/products/partial_delivery_from_central_kitchen_report",
            component: PartialDeliveryFromCentralKitchenReport,
          },
          {
            path: "/items/partial_delivery_from_central_store_report",
            component: PartialDeliveryFromCentralStoreReport,
          },
          {
            path: "/items/partial_delivery_from_supplier_report",
            component: PartialDeliveryFromSupplierReport,
          },
          {
            path: "/user_based_transaction_report",
            component: UserBasedTransactionReport,
          },
          { path: "/po_costing_report_items", component: ItemsPOCostingReport},
          { path: "/po_costing_report_products", component: ProductsPOCostingReport},
          
          { path: "/po_cost_difference_report_items", component: ItemsPOCostDifferenceReport},
          { path: "/po_cost_difference_report_products", component: ProductsPOCostDifferenceReport},
          
          { path: "/items/item_arrangement_report", component: ItemArrangementReport},
          { path: "/items/item_location_arrangement_report", component: ItemLocDriverArrangementReport},


          {
            path: "/items/item_order_report",
            component: ItemOrderReport,
          },
          {
            path: "/items/branchwise_item_order_report",
            component: BranchwiseItemOrderReport,
          },
          {
            path: "/items/itemwise_order_report",
            component: ItemwiseOrderReport,
          },
          {
            path: "/items/item_categorywise_order_report",
            component: ItemCategorywiseOrderReport,
          },
          {
            path: "/products/product_order_report",
            component: ProductOrderReport,
          },
          {
            path: "/products/branchwise_product_order_report",
            component: BranchwiseProductOrderReport,
          },
          {
            path: "/products/productwise_order_report",
            component: ProductwiseOrderReport,
          },
          {
            path: "/products/branchwise_used_cost_report",
            component: BranchwiseProductUsedInventoriesCostReport,
          },
          {
            path: "/products/branchwise_used_report",
            component: BranchwiseProductUsedInventoriesReport,
          },
          {
            path: "/items/branchwise_used_cost_report",
            component: BranchwiseItemUsedInventoriesCostReport,
          },
          {
            path: "/items/branchwise_used_report",
            component: BranchwiseItemUsedInventoriesReport,
          },
           {
            path: "/items/item_wise_total_report",
            component: ItemWiseUsedTotalReport,
          },
          {
            path: "/products/branchwise_balance_report",
            component: BranchwiseProductBalanceInventoriesReport,
          },
          {
            path: "/items/branchwise_balance_report",
            component: BranchwiseItemBalanceInventoriesReport,
          },
          {
            path: "/products/branchwise_expiring_report",
            component: BranchwiseProductExpiringInventoriesReport,
          },
          {
            path: "/items/branchwise_expiring_report",
            component: BranchwiseItemExpiringInventoriesReport,
          },
          {
            path: "/products/branchwise_discarded_report",
            component: BranchwiseProductDiscardedInventoriesReport,
          },
          {
            path: "/items/branchwise_discarded_report",
            component: BranchwiseItemDiscardedInventoriesReport,
          },
          {
            path: "/products/branchwise_wasted_report",
            component: BranchwiseProductWastedInventoriesReport,
          },
          {
            path: "/items/branchwise_wasted_report",
            component: BranchwiseItemWastedInventoriesReport,
          },
          {
            path: "/products/deficiency_report",
            component: ProductDeficiencyReport,
          },
          {
            path: "/items/deficiency_report",
            component: ItemDeficiencyReport,
          },
          {
            path: "/products/highly_used_product_report",
            component: HighlyUsedProductReport,
          },
          {
            path: "/items/highly_used_item_report",
            component: HighlyUsedItemReport,
          },
          {
            path: "/products/highly_ordered_product_report",
            component: HighlyOrderedProductReport,
          },
          {
            path: "/items/highly_ordered_item_report",
            component: HighlyOrderedItemReport,
          },
          {
            path: "/items/supplier_monthly_report",
            component: SupplierMonthlyReport,
          },
          { path: "/items/supplier_return_report",component: SupplierReturnReport},
          { path: "/items/supplier_change_report",component: SupplierChangeReport},
          { path: "/items/item_cost_trend_report", component: ItemCostTrendReport},
          { path: "/items/item_replacement_report", component: ItemReplacementReport},
          // { path: "/cost_of_goods_sold_report", component: CostOfGoodsSoldReport},
          { path: "/cost_of_goods_sold_products_report",component: CostOfGoodsSoldProductsReport},
          { path: "/cost_of_goods_sold_items_report", component: CostOfGoodsSoldItemsReport },
          { path: "/cogs_items_date_range_report", component: COGSItemsDateRangeReport},
          { path: "/cogs_products_date_range_report", component: COGSProductsDateRangeReport},
          
          {
            path: "/branch_item_transfer_report",
            component: BranchItemTransferReport,
          },
          {
            path: "/branch_product_transfer_report",
            component: BranchProductTransferReport,
          },
          // Procurement
          { path: "/add_requisition", component: AddRequisition },
          { path: "/branchwise_requisition", component: BranchWiseRequisition },
          { path: "/mainstorewise_requisition", component: MainStoreWiseRequisition },
          { path: "/substorewise_requisition", component: SubStoreWiseRequisition },
          { path: "/branch_po_requests", component: BranchPORequests },
          { path: "/mainstore_po_requests", component: MainStorePORequests },
          { path: "/substore_po_requests", component: SubStorePORequests },
          { path: "/branch_po_generation", component: BranchPOGeneration },
          { path: "/mainstore_po_generation", component: MainStotorePOGeneration },
          { path: "/substore_po_generation", component: SubStotorePOGeneration },

          {
            path: "/supplierwise_requisition",
            component: SupplierWiseRequisition,
          },
          { path: "/all_po", component: ViewPO },

          { path: "/all_po_owner", component: ViewPO_Owner },

          { path: "/add_branches", component: AddBranches },
          { path: "/update_branch", component: UpdateBranches },
          { path: "/branch_items", component: BranchItems },
          { path: "/mainstore_items", component: MainStoreItems },
          { path: "/branch_products", component: BranchProducts },
          {
            path: "/finished_products/new_orders",
            component: FinishedProductNewOrders,
          },
          {
            path: "/finished_products/orders_in_process",
            component: FinishedProductOrdersInProcess,
          },
          {
            path: "/finished_products/closed_orders",
            component: FinishedProductClosedOrders,
          },
          {
            path: "/finished_products/all_orders_new",
            component: FinishedProductAllOrders_New,
          },

          {
            path: "/items/new_orders",
            component: ItemNewOrders,
          },
          { path: "/items/orders_in_process", component: ItemOrdersInProcess},
          { path: "/items/urgent_orders", component: ItemOrdersInProcess },

          {
            path: "/items/edit_orders",
            component: ItemEditOrders,
          },
          {
            path: "/items/closed_orders",
            component: ItemClosedOrders,
          },

          // Inventory Pages
          {
            path: "/finished_products/update_inventory",
            component: FinishedProductUpdateInventory,
          },
          {
            path: "/finished_products/view_inventory",
            component: FinishedProductViewInventory,
          },
          {
            path: "/finished_products/transfer_inventory",
            component: FinishedProductTransferInventory,
          },
          {
            path: "/finished_products/view_branchwise_inventory",
            component: FinishedProductViewInventory_Branch_ByCentre,
          },
          {
            path: "/items/update_inventory",
            component: ItemUpdateInventory,
          },
          {
            path: "/items/view_inventory",
            component: ItemViewInventory,
          },
          {
            path: "/items/used_inventory",
            component: ItemUsedInventory,
          },
          {
            path: "/items/transfer_inventory",
            component: ItemTransferInventory,
          },
          {
            path: "/items/view_branchwise_inventory",
            component: ItemViewInventory_Branch_ByCentre,
          },

          { path: "/supplier-Update", component: UpdateSupplier },
          { path: "/add_supplier", component: AddSupplier },

          { path: "/users-adduser", component: AddUser },
          { path: "/users-updateuser", component: AllUsers },

          { path: "/add_item", component: AddItem },
          { path: "/add_item_uom", component: AddItemUnits },
          { path: "/all_items", component: AllItems },
          { path: "/item_categories", component: AddItemCategory },
          { path: "/categories-update", component: AllItemCategories },

          { path: "/add_store", component: AddStore },
          { path: "/branch_category", component: BranchCategory },
          { path: "/update_store", component: AllStore },

          { path: "/add_product", component: AddProduct },
          { path: "/add_product_uom", component: AddProductUnits },
          { path: "/all_products", component: AllProducts },
          { path: "/add_product_category", component: AddProductCategory },
          { path: "/product_categories", component: AllProductCategories },

          // Equipment
          { path: "/add_equipment", component: AddEquipment },
          { path: "/update_equipment", component: UpdateEquipments },
          { path: "/equipments/central/inventory", component: CentralEquipmentInventory },
          { path: "/update_equipment_category", component:  AllEquipCategories},
          { path: "/add_equipment_category", component:  AddEquipCategory},
          { path: "/add_equipment_unit", component:  AddEquipmentUnits},

          { path: "/add_equipments_supplier", component: AddEquipmentsSupplier },
          { path: "/update_equipments_supplier", component: UpdateEquipmentsSupplier },

          { path: "/user-changepassword", component: ChangePassword },

          // this route should be at the end of all other routes
          {
            path: "/",
            exact: true,
            component: () => <Redirect to="/dashboard" />,
          },
        ];
      } else if (role === "Operations Manager" ||role === "Client Admin") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/debug", component: DebugPage },
          { path: "/cogs_debug", component: COGSDebug },
          { path: "/app_settings", component: AppSettings },
          { path: "/add_location", component: AddLocation },
          { path: "/all_locations", component: AllLocations },
          { path: "/add_vehicle", component: AddVehicle },
          { path: "/all_vehicles", component: AllVehicle },
          { path: "/correction_report", component: CorrectionReport},
          { path: "/centralstore/items/return", component: CentralStoreItemReturn},
          { path: "/centralstore/items/allreturn", component: CentralStoreItemAllReturn},      
          { path: "/notifications", component: Notifications },
          { path: "/items/alltransfers", component: AllItemDirectTransfers },
          { path: "/finished_products/alltransfers", component: AllFPDirectTransfers },
          { path: "/equipments/centralkitchen/inventory", component: CentralKitchenEquipmentInventory },
          { path: "/finished_products/transfer_inventory_by_branch", component: FinishedProductTransferInventory_ByBranch},
          { path: "/finished_products/transfer_inventory", component: FinishedProductTransferInventory},
          { path: "/finished_products/view_all_branch_inventory", component: FinishedProductViewInventory_AllBranches},
          { path: "/items/transfer_inventory_by_branch", component: ItemTransferInventory_ByBranch},
          { path: "/items/transfer_inventory", component: ItemTransferInventory},
          { path: "/items/view_all_branch_inventory", component: ItemViewInventory_AllBranches},
          { path: "/finished_products/view_branch_inventory", component: FinishedProductViewInventory_Branch},
          { path: "/finished_products/view_branch_inventory_kitchen", component: FinishedProductViewInventory_Branch_Kitchen},
          { path: "/finished_products/expired_inventory", component: FinishedProductExpiredInventory_Branch},

          { path: "/item_order_correction", component: ItemOrderCorrection},
          { path: "/finished_poduct_order_correction", component: FPOrderCorrection},
          { path: "/item_withdrawl_correction", component: ItemWithdrawlCorrection},
          { path: "/finished_product_withdrawl_correction", component: FPWithdrawlCorrection},
          { path: "/purchase_order_correction", component: POCorrection},
          //Reports
          { path: "/branchwise_summary_report", component: BranchwiseSummaryReport},
          { path: "/items/supplier_food_consumption_report", component: FoodConsumptionReports },
          { path: "/items/branch_target_achievement_report", component: FoodCostAndTargetAchievementReport },
          { path: "/free_goods_report", component: FreeGoodsReport },
          
          {
            path: "/products/partial_delivery_from_central_kitchen_report",
            component: PartialDeliveryFromCentralKitchenReport,
          },
          {
            path: "/items/partial_delivery_from_central_store_report",
            component: PartialDeliveryFromCentralStoreReport,
          },
          {
            path: "/items/partial_delivery_from_supplier_report",
            component: PartialDeliveryFromSupplierReport,
          },
          {
            path: "/user_based_transaction_report",
            component: UserBasedTransactionReport,
          },
          {
            path: "/items/view_branch_inventory",
            component: ItemViewInventory_Branch,
          },
          {
            path: "/items/expired_inventory",
            component: ItemExpiredInventory_Branch,
          },
          { path: "/po_costing_report_items", component: ItemsPOCostingReport},
          { path: "/po_costing_report_products", component: ProductsPOCostingReport},
          
          { path: "/po_cost_difference_report_items", component: ItemsPOCostDifferenceReport},
          { path: "/po_cost_difference_report_products", component: ProductsPOCostDifferenceReport},
          
          { path: "/items/item_arrangement_report",component: ItemArrangementReport},
          { path: "/items/item_location_arrangement_report", component: ItemLocDriverArrangementReport},

          {
            path: "/items/item_order_report",
            component: ItemOrderReport,
          },
          {
            path: "/items/view_branch_inventory_kitchen",
            component: ItemViewInventory_Branch_Kitchen,
          },
          {
            path: "/items/branchwise_item_order_report",
            component: BranchwiseItemOrderReport,
          },
          {
            path: "/items/itemwise_order_report",
            component: ItemwiseOrderReport,
          },
          {
            path: "/items/item_categorywise_order_report",
            component: ItemCategorywiseOrderReport,
          },
          {
            path: "/products/product_order_report",
            component: ProductOrderReport,
          },
          {
            path: "/products/branchwise_product_order_report",
            component: BranchwiseProductOrderReport,
          },
          {
            path: "/products/productwise_order_report",
            component: ProductwiseOrderReport,
          },
          {
            path: "/products/branchwise_used_cost_report",
            component: BranchwiseProductUsedInventoriesCostReport,
          },
          {
            path: "/products/branchwise_used_report",
            component: BranchwiseProductUsedInventoriesReport,
          },
          {
            path: "/items/branchwise_used_cost_report",
            component: BranchwiseItemUsedInventoriesCostReport,
          },
          {
            path: "/items/branchwise_used_report",
            component: BranchwiseItemUsedInventoriesReport,
          },
           {
            path: "/items/item_wise_total_report",
            component: ItemWiseUsedTotalReport,
          },
          {
            path: "/products/branchwise_balance_report",
            component: BranchwiseProductBalanceInventoriesReport,
          },
          {
            path: "/items/branchwise_balance_report",
            component: BranchwiseItemBalanceInventoriesReport,
          },
          {
            path: "/products/branchwise_expiring_report",
            component: BranchwiseProductExpiringInventoriesReport,
          },
          {
            path: "/items/branchwise_expiring_report",
            component: BranchwiseItemExpiringInventoriesReport,
          },
          {
            path: "/products/branchwise_discarded_report",
            component: BranchwiseProductDiscardedInventoriesReport,
          },
          {
            path: "/items/branchwise_discarded_report",
            component: BranchwiseItemDiscardedInventoriesReport,
          },
          {
            path: "/products/branchwise_wasted_report",
            component: BranchwiseProductWastedInventoriesReport,
          },
          {
            path: "/items/branchwise_wasted_report",
            component: BranchwiseItemWastedInventoriesReport,
          },
          {
            path: "/products/deficiency_report",
            component: ProductDeficiencyReport,
          },
          {
            path: "/items/deficiency_report",
            component: ItemDeficiencyReport,
          },
          {
            path: "/products/highly_used_product_report",
            component: HighlyUsedProductReport,
          },
          {
            path: "/items/highly_used_item_report",
            component: HighlyUsedItemReport,
          },
          {
            path: "/products/highly_ordered_product_report",
            component: HighlyOrderedProductReport,
          },
          {
            path: "/items/highly_ordered_item_report",
            component: HighlyOrderedItemReport,
          },
          {
            path: "/items/supplier_monthly_report",
            component: SupplierMonthlyReport,
          },
          { path: "/items/supplier_return_report",component: SupplierReturnReport},
          { path: "/items/supplier_change_report",component: SupplierChangeReport},
          { path: "/items/item_cost_trend_report", component: ItemCostTrendReport},
          { path: "/items/item_replacement_report", component: ItemReplacementReport},
          // { path: "/cost_of_goods_sold_report", component: CostOfGoodsSoldReport },
          { path: "/cost_of_goods_sold_products_report", component: CostOfGoodsSoldProductsReport},
          { path: "/cost_of_goods_sold_items_report", component: CostOfGoodsSoldItemsReport},
          { path: "/cogs_items_date_range_report", component: COGSItemsDateRangeReport},
          { path: "/cogs_products_date_range_report", component: COGSProductsDateRangeReport},
          
          {
            path: "/branch_item_transfer_report",
            component: BranchItemTransferReport,
          },
          {
            path: "/branch_product_transfer_report",
            component: BranchProductTransferReport,
          },
          // Procurement
          { path: "/add_requisition", component: AddRequisition },
          { path: "/branchwise_requisition", component: BranchWiseRequisition },
          { path: "/mainstorewise_requisition", component: MainStoreWiseRequisition },
          { path: "/substorewise_requisition", component: SubStoreWiseRequisition },
          { path: "/mainstore_po_requests", component: MainStorePORequestsCentre },
          { path: "/substore_po_requests", component: SubStorePORequestsCentre },


          {
            path: "/supplierwise_requisition",
            component: SupplierWiseRequisition,
          },
          { path: "/all_po", component: ViewPO },

          { path: "/branch_po_requests", component: BranchPORequests },
          { path: "/branch_po_generation", component: BranchPOGeneration },
          { path: "/mainstore_po_generation", component: MainStotorePOGeneration },
          { path: "/substore_po_generation", component: SubStotorePOGeneration },

          { path: "/add_store", component: AddStore },
          { path: "/branch_category", component: BranchCategory },
          { path: "/update_store", component: AllStore },

          { path: "/add_branches", component: AddBranches },
          { path: "/update_branch", component: UpdateBranches },
          { path: "/branch_items", component: BranchItems },
          { path: "/items/map_to_all", component: ItemsMapToAll },
          { path: "/products/map_to_all", component: ProductsMapToAll },
          { path: "/mainstore_items", component: MainStoreItems },
          { path: "/branch_products", component: BranchProducts },
          {
            path: "/finished_products/new_orders",
            component: FinishedProductNewOrders,
          },
          {
            path: "/finished_products/orders_in_process",
            component: FinishedProductOrdersInProcess,
          },
          {
            path: "/finished_products/closed_orders",
            component: FinishedProductClosedOrders,
          },
          {
            path: "/finished_products/all_orders_new",
            component: FinishedProductAllOrders_New,
          },

          {
            path: "/items/new_orders",
            component: ItemNewOrders,
          },
          { path: "/items/orders_in_process", component: ItemOrdersInProcess},
          { path: "/items/urgent_orders", component: ItemOrdersInProcess },
          {
            path: "/items/edit_orders",
            component: ItemEditOrders,
          },
          {
            path: "/items/closed_orders",
            component: ItemClosedOrders,
          },

          // Inventory Pages
          {
            path: "/finished_products/update_inventory",
            component: FinishedProductUpdateInventory,
          },
          {
            path: "/finished_products/view_inventory",
            component: FinishedProductViewInventory,
          },
          {
            path: "/finished_products/transfer_inventory",
            component: FinishedProductTransferInventory,
          },
          {
            path: "/finished_products/view_branchwise_inventory",
            component: FinishedProductViewInventory_Branch_ByCentre,
          },

          {
            path: "/items/update_inventory",
            component: ItemUpdateInventory,
          },
          {
            path: "/items/view_inventory",
            component: ItemViewInventory,
          },
          {
            path: "/items/used_inventory",
            component: ItemUsedInventory,
          },
          {
            path: "/items/transfer_inventory",
            component: ItemTransferInventory,
          },
          {
            path: "/items/view_branchwise_inventory",
            component: ItemViewInventory_Branch_ByCentre,
          },

          { path: "/supplier-Update", component: UpdateSupplier },
          { path: "/add_supplier", component: AddSupplier },

          { path: "/users-adduser", component: AddUser },
          { path: "/users-updateuser", component: AllUsers },

          { path: "/add_item", component: AddItem },
          { path: "/all_items", component: AllItems },
          { path: "/add_item_uom", component: AddUnits },
          { path: "/item_categories", component: AddItemCategory },
          { path: "/categories-update", component: AllItemCategories },

          { path: "/add_product", component: AddProduct },
          { path: "/all_products", component: AllProducts },
          { path: "/add_product_uom", component: AddProductUnits },
          { path: "/add_product_category", component: AddProductCategory },
          { path: "/product_categories", component: AllProductCategories },

          { path: "/user-changepassword", component: ChangePassword },

          // this route should be at the end of all other routes
          {
            path: "/",
            exact: true,
            component: () => <Redirect to="/dashboard" />,
          },
        ];
      } else if (role === "Central Store Manager") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/app_settings", component: AppSettings },
          { path: "/create_draft", component: CreateDraftPO },
          { path: "/add_location", component: AddLocation },
          { path: "/all_locations", component: AllLocations },
          { path: "/add_vehicle", component: AddVehicle },
          { path: "/all_vehicles", component: AllVehicle },
          { path: "/notifications", component: Notifications },
          { path: "/items/alltransfers", component: AllItemDirectTransfers },
          { path: "/centralstore/items/return", component: CentralStoreItemReturn},
          { path: "/centralstore/items/allreturn", component: CentralStoreItemAllReturn},
          { path: "/items/map_to_all", component: ItemsMapToAll },
          { path: "/products/map_to_all", component: ProductsMapToAll },

          //Reports
          { path: "/items/item_arrangement_report", component: ItemArrangementReport},
          { path: "/items/item_location_arrangement_report", component: ItemLocDriverArrangementReport},
          { path: "/items/partial_delivery_from_central_store_report", component: PartialDeliveryFromCentralStoreReport},
          { path: "/items/wasted_inventory", component: CentraStoreWastedInventory },
          {
            path: "/items/item_order_report",
            component: ItemOrderReport,
          },
          {
            path: "/items/branchwise_item_order_report",
            component: BranchwiseItemOrderReport,
          },
          {
            path: "/items/itemwise_order_report",
            component: ItemwiseOrderReport,
          },
          {
            path: "/items/item_categorywise_order_report",
            component: ItemCategorywiseOrderReport,
          },
          { path: "/po_costing_report_items", component: ItemsPOCostingReport },
          { path: "/po_costing_report_products", component: ProductsPOCostingReport},
          

          // Procurement
          { path: "/add_requisition", component: AddRequisition },
          { path: "/branchwise_requisition", component: BranchWiseRequisition },
          { path: "/mainstorewise_requisition", component: MainStoreWiseRequisition },
          { path: "/substorewise_requisition", component: SubStoreWiseRequisition },
          { path: "/branch_po_requests", component: BranchPORequests },
          { path: "/mainstore_po_requests", component: MainStorePORequestsCentre },
          { path: "/substore_po_requests", component: SubStorePORequestsCentre },
          { path: "/branch_po_generation", component: BranchPOGeneration },
          { path: "/mainstore_po_generation", component: MainStotorePOGeneration },
          { path: "/substore_po_generation", component: SubStotorePOGeneration },

          { path: "/supplierwise_requisition", component: SupplierWiseRequisition},
          { path: "/all_po", component: ViewPO },

          { path: "/add_branches", component: AddBranches },
          { path: "/update_branch", component: UpdateBranches },
          { path: "/branch_items", component: BranchItems },
          { path: "/mainstore_items", component: MainStoreItems },
          { path: "/branch_products", component: BranchProducts },

          //Equipments Order
          { path: "/equipments/add_orders/central", component: AddEquipOrderByCentral },
          { path: "/equipments/all_orders/central", component: AllEquipOrderByCentral },

          {
            path: "/finished_products/new_orders",
            component: FinishedProductNewOrders,
          },
          {
            path: "/finished_products/orders_in_process",
            component: FinishedProductOrdersInProcess,
          },
          {
            path: "/finished_products/closed_orders",
            component: FinishedProductClosedOrders,
          },
          {
            path: "/finished_products/all_orders_new",
            component: FinishedProductAllOrders_New,
          },

          {
            path: "/items/new_orders",
            component: ItemNewOrders,
          },
          { path: "/items/orders_in_process", component: ItemOrdersInProcess},
          { path: "/items/urgent_orders", component: ItemOrdersInProcess },

          {
            path: "/items/edit_orders",
            component: ItemEditOrders,
          },
          {
            path: "/items/closed_orders",
            component: ItemClosedOrders,
          },

          // Inventory Pages
          {
            path: "/finished_products/update_inventory",
            component: FinishedProductUpdateInventory,
          },
          {
            path: "/finished_products/view_inventory",
            component: FinishedProductViewInventory,
          },
          {
            path: "/finished_products/transfer_inventory",
            component: FinishedProductTransferInventory,
          },
          {
            path: "/finished_products/view_branchwise_inventory",
            component: FinishedProductViewInventory_Branch_ByCentre,
          },
          {
            path: "/items/update_inventory",
            component: ItemUpdateInventory,
          },
          {
            path: "/items/view_inventory",
            component: ItemViewInventory,
          },
          { path: "/equipments/central/inventory", component: CentralEquipmentInventory },
          {
            path: "/items/used_inventory",
            component: ItemUsedInventory,
          },
          {
            path: "/items/transfer_inventory",
            component: ItemTransferInventory,
          },
          {
            path: "/items/view_branchwise_inventory",
            component: ItemViewInventory_Branch_ByCentre,
          },

          { path: "/supplier-Update", component: UpdateSupplier },
          { path: "/add_supplier", component: AddSupplier },

          { path: "/users-adduser", component: AddUser },
          { path: "/users-updateuser", component: AllUsers },

          { path: "/add_item", component: AddItem },
          { path: "/add_item_uom", component: AddItemUnits },
          { path: "/all_items", component: AllItems },
          { path: "/item_categories", component: AddItemCategory },
          { path: "/categories-update", component: AllItemCategories },

          { path: "/add_product", component: AddProduct },
          { path: "/all_products", component: AllProducts },
          { path: "/add_product_category", component: AddProductCategory },
          { path: "/product_categories", component: AllProductCategories },

          // Transfer Items
          { path: "/items/transfer/from/central", component: ItemsDirectTransferFromCentral },
          { path: "/items/centre/all_item_requests", component: CentreAllItemRequest },

          //Place Orders
          { path: "/items/add_new_order/from/central", component: AddNewItemOrderFromCentral },
          { path: "/items/centre/all_item_orders", component: AllItemOrder },


          { path: "/user-changepassword", component: ChangePassword },

          // this route should be at the end of all other routes
          {
            path: "/",
            exact: true,
            component: () => <Redirect to="/dashboard" />,
          },
        ];
      } else if (role === "Central Store Assistant") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/user-changepassword", component: ChangePassword },
          { path: "/all_po", component: ViewPO },
          { path: "/create_draft", component: CreateDraftPO },
          { path: "/add_location", component: AddLocation },
          { path: "/all_locations", component: AllLocations },
          { path: "/add_vehicle", component: AddVehicle },
          { path: "/all_vehicles", component: AllVehicle },
          {
            path: "/items/new_orders",
            component: ItemNewOrders,
          },
          { path: "/items/orders_in_process", component: ItemOrdersInProcess},
          { path: "/items/urgent_orders", component: ItemOrdersInProcess },

          {
            path: "/items/edit_orders",
            component: ItemEditOrders,
          },
          {
            path: "/items/closed_orders",
            component: ItemClosedOrders,
          },
          {
            path: "/items/update_inventory",
            component: ItemUpdateInventory,
          },
          {
            path: "/items/view_inventory",
            component: ItemViewInventory,
          },
          { path: "/supplier-Update", component: UpdateSupplier },
          { path: "/branch_items", component: BranchItems },
          { path: "/items/map_to_all", component: ItemsMapToAll },
          { path: "/products/map_to_all", component: ProductsMapToAll },
          { path: "/mainstore_items", component: MainStoreItems },
          { path: "/users-adduser", component: AddUser },
          { path: "/users-updateuser", component: AllUsers },
          { path: "/items/item_arrangement_report", component: ItemArrangementReport},
          { path: "/items/item_location_arrangement_report", component: ItemLocDriverArrangementReport},

          {
            path: "/products/deficiency_report",
            component: ProductDeficiencyReport,
          },
          {
            path: "/items/deficiency_report",
            component: ItemDeficiencyReport,
          },
          // this route should be at the end of all other routes
          {
            path: "/",
            exact: true,
            component: () => <Redirect to="/dashboard" />,
          },
        ];
      } else if (role === "Storekeeper") {
              routes = [
                { path: "/dashboard", component: Dashboard },
                { path: "/user-changepassword", component: ChangePassword },
                { path: "/dashboard", component: Dashboard },
                { path: "/create_draft", component: CreateDraftPO },
                { path: "/notifications", component: Notifications },
                { path: "/items/alltransfers", component: AllItemDirectTransfers },
                { path: "/centralstore/items/return", component: CentralStoreItemReturn},
                { path: "/centralstore/items/allreturn", component: CentralStoreItemAllReturn},
                { path: "/items/map_to_all", component: ItemsMapToAll },
                { path: "/products/map_to_all", component: ProductsMapToAll },
      
                //Reports
                { path: "/products/branchwise_discarded_report", component: BranchwiseProductDiscardedInventoriesReport},
                { path: "/items/branchwise_discarded_report", component: BranchwiseItemDiscardedInventoriesReport},
                { path: "/products/branchwise_wasted_report",component: BranchwiseProductWastedInventoriesReport},
                { path: "/items/branchwise_wasted_report", component: BranchwiseItemWastedInventoriesReport },
                { path: "/items/item_arrangement_report", component: ItemArrangementReport},
                { path: "/items/item_location_arrangement_report", component: ItemLocDriverArrangementReport},
                { path: "/items/partial_delivery_from_central_store_report", component: PartialDeliveryFromCentralStoreReport},
                { path: "/items/wasted_inventory", component: CentraStoreWastedInventory },
                { path: "/items/item_order_report",component: ItemOrderReport},
                { path: "/items/branchwise_item_order_report", component: BranchwiseItemOrderReport},
                { path: "/items/itemwise_order_report", component: ItemwiseOrderReport},
                { path: "/items/item_categorywise_order_report",component: ItemCategorywiseOrderReport},
                { path: "/po_costing_report_items",component: ItemsPOCostingReport},
                { path: "/po_costing_report_products", component: ProductsPOCostingReport},
                
      
                // Procurement
                { path: "/add_requisition", component: AddRequisition },
                { path: "/branchwise_requisition", component: BranchWiseRequisition },
                { path: "/mainstorewise_requisition", component: MainStoreWiseRequisition },
                { path: "/substorewise_requisition", component: SubStoreWiseRequisition },
                { path: "/branch_po_requests", component: BranchPORequests },
                { path: "/mainstore_po_requests", component: MainStorePORequestsCentre },
                { path: "/substore_po_requests", component: SubStorePORequestsCentre },
                { path: "/branch_po_generation", component: BranchPOGeneration },
                { path: "/mainstore_po_generation", component: MainStotorePOGeneration },
                { path: "/substore_po_generation", component: SubStotorePOGeneration },
                { path: "/supplierwise_requisition", component: SupplierWiseRequisition},
                { path: "/all_po", component: ViewPO },
                { path: "/branch_items", component: BranchItems },
                { path: "/mainstore_items", component: MainStoreItems },
                { path: "/branch_products", component: BranchProducts },
      
                //Equipments Order
                { path: "/equipments/add_orders/central", component: AddEquipOrderByCentral },
                { path: "/equipments/all_orders/central", component: AllEquipOrderByCentral },
      
                { path: "/finished_products/new_orders",component: FinishedProductNewOrders},
                { path: "/finished_products/orders_in_process", component: FinishedProductOrdersInProcess},
                { path: "/finished_products/closed_orders", component: FinishedProductClosedOrders},
                { path: "/finished_products/all_orders_new", component: FinishedProductAllOrders_New},
      
                { path: "/items/new_orders", component: ItemNewOrders},
                { path: "/items/orders_in_process",component: ItemOrdersInProcess},
                { path: "/items/urgent_orders", component: ItemOrdersInProcess },
                { path: "/items/edit_orders", component: ItemEditOrders},
                { path: "/items/closed_orders", component: ItemClosedOrders},
      
                // Inventory Pages
                { path: "/finished_products/update_inventory",component: FinishedProductUpdateInventory},
                { path: "/finished_products/view_inventory",component: FinishedProductViewInventory},
                { path: "/finished_products/transfer_inventory", component: FinishedProductTransferInventory},
                { path: "/finished_products/view_branchwise_inventory", component: FinishedProductViewInventory_Branch_ByCentre},
                { path: "/items/update_inventory", component: ItemUpdateInventory},
                { path: "/items/view_inventory", component: ItemViewInventory},
                { path: "/equipments/central/inventory", component: CentralEquipmentInventory },
                { path: "/items/used_inventory",component: ItemUsedInventory},
                { path: "/items/transfer_inventory",component: ItemTransferInventory},
                { path: "/items/view_branchwise_inventory", component: ItemViewInventory_Branch_ByCentre},
      
                // Transfer Items
                { path: "/items/transfer/from/central", component: ItemsDirectTransferFromCentral },
                { path: "/items/centre/all_item_requests", component: CentreAllItemRequest },
      
                //Place Orders
                { path: "/items/add_new_order/from/central", component: AddNewItemOrderFromCentral },
                { path: "/items/centre/all_item_orders", component: AllItemOrder },
                { path: "/notifications", component: Notifications },
                { path: "/branch/items/return", component: BranchItemsReturn},
                { path: "/branch/items/allreturn", component: BranchItemAllReturn},
                { path: "/finished_products/urgent_orders", component: FPUrgentOrders},
                { path: "/items/alltransfers", component: AllItemDirectTransfers },
                { path: "/finished_products/alltransfers", component: AllFPDirectTransfers },
                { path: "/items/alldrafts", component: AllDrafts},
                { path: "/finished_products/direct_transfer", component: FinishedProductsDirectTransfer },
      
                // Reports
                { path: "/products/product_arrangement_report", component: ProductArrangementReport},
                { path: "/products/product_category_driver_arrangement_report", component: ProductCategoryDriverArrangementReport},
                { path: "/products/wasted_inventory", component: CentraKitchenFPWastedInventory },
      
                { path: "/products/product_order_report", component: ProductOrderReport},
                { path: "/finished_products/orders_in_process/dashboard", component: FinishedProductOrdersInProcessForDashboard},
                { path: "/products/branchwise_product_order_report", component: BranchwiseProductOrderReport},
                { path: "/products/productwise_order_report", component: ProductwiseOrderReport},
                { path: "/products/product_sectionwise_order_report", component: ProductSectionwiseOrderReport},
      
                // Branch Functionality
                { path: "/branch_po_requests", component: BranchPORequests_Branch},
                { path: "/branch_requisition_request", component: BranchRequisitionRequest},
                { path: "/branch_all_po", component: BranchAllPO },
                { path: "/finished_products/add_order", component: FinishedProductAddOrder},
                { path: "/finished_products/all_orders", component: FinishedProductAllOrders},
      
                { path: "/items/add_order", component: ItemAddOrder},
                { path: "/items/all_orders", component: ItemAllOrders},
      
                { path: "/equipments/add_order", component: BranchEquipmentAddOrder },
                { path: "/equipments/all_orders", component: BranchEquipmentAllOrder },
      
                { path: "/items/order/from/sub_store", component: BranchItemAddOrdersToSubStore},
                { path: "/items/allorders/from/sub_store", component: BranchItemAllOrdersToSubStore},
      
                { path: "/items/view_branch_inventory", component: ItemViewInventory_Branch},
                { path: "/branch/equipments_inventory", component: BranchEquipmentInventory},
      
                { path: "/items/view_branch_inventory_kitchen", component: ItemViewInventory_Branch_Kitchen},
                { path: "/items/view_branch_inventory_store", component: ItemViewInventory_Branch_Store},
                { path: "/items/transfer_inventory", component: ItemTransferInventory_Branch},
                { path: "/items/transfer_inventory_by_branch", component: ItemTransferInventory_ByBranch},
                { path: "/closing/items", component: BranchItemClosing },
                { path: "/closing/finished_products", component: BranchFinishedProductClosing},
                { path: "/finished_products/view_branch_inventory", component: FinishedProductViewInventory_Branch},
                { path: "/finished_products/view_branch_inventory_kitchen", component: FinishedProductViewInventory_Branch_Kitchen},
                { path: "/finished_products/transfer_inventory_by_branch", component: FinishedProductTransferInventory_ByBranch},
                { path: "/finished_products/transfer_inventory", component: FinishedProductTransferInventory},
                { path: "/finished_products/view_all_branch_inventory", component: FinishedProductViewInventory_AllBranches},
                { path: "/items/view_all_branch_inventory",component: ItemViewInventory_AllBranches},
                { path: "/finished_products/discarded_inventory", component: FinishedProductDiscardedInventory_Branch},
                { path: "/items/discarded_inventory", component: ItemDiscardedInventory_Branch},
                { path: "/finished_products/wasted_inventory", component: FinishedProductWastedInventory_Branch},
                { path: "/items/wasted_inventory", component: ItemWastedInventory_Branch},
                { path: "/finished_products/expired_inventory", component: FinishedProductExpiredInventory_Branch},
                { path: "/items/expired_inventory", component: ItemExpiredInventory_Branch},
                { path: "/items/add_order", component: ItemAddOrder},
                { path: "/items/all_orders", component: ItemAllOrders},
                { path: "/items/view_branch_inventory", component: ItemViewInventory_Branch},
                { path: "/items/view_branch_inventory_kitchen", component: ItemViewInventory_Branch_Kitchen},
                { path: "/items/expired_inventory", component: ItemExpiredInventory_Branch},
      
                //Equipments Order
                { path: "/equipments/add_orders/centralkitchen", component: AddEquipOrderByCentral},
                { path: "/equipments/all_orders/centralkitchen", component: AllEquipOrderByCentral},
      
                // Procurement
                { path: "/add_requisition", component: AddRequisition },
                { path: "/all_po", component: ViewPO },
                { path: "/add_branches", component: AddBranches },
                { path: "/update_branch", component: UpdateBranches },
                { path: "/products/map_to_all", component: ProductsMapToAll },
                { path: "/branch_products", component: BranchProducts },
                { path: "/finished_products/new_orders", component: FinishedProductNewOrders},
                { path: "/finished_products/orders_in_process", component: FinishedProductOrdersInProcess},
                { path: "/finished_products/closed_orders",component: FinishedProductClosedOrders},
                { path: "/finished_products/all_orders_new", component: FinishedProductAllOrders_New},
      
                // Inventory Pages
                { path: "/finished_products/update_inventory", component: FinishedProductUpdateInventory},
                { path: "/finished_products/view_inventory", component: FinishedProductViewInventory},
                { path: "/finished_products/transfer_inventory", component: FinishedProductTransferInventory},
                { path: "/finished_products/view_branchwise_inventory", component: FinishedProductViewInventory_Branch_ByCentre},
                { path: "/equipments/centralkitchen/inventory", component: CentralKitchenEquipmentInventory},
                { path: "/items/update_inventory", component: ItemUpdateInventory},
                { path: "/items/view_inventory", component: ItemViewInventory},
                { path: "/items/used_inventory", component: ItemUsedInventory},
                { path: "/items/transfer_inventory", component: ItemTransferInventory},
                { path: "/items/view_branchwise_inventory", component: ItemViewInventory_Branch_ByCentre},
      
                {
                  path: "/",
                  exact: true,
                  component: () => <Redirect to="/dashboard" />,
                },
              ];
      } else if (role === "Central Kitchen Manager") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/notifications", component: Notifications },
          { path: "/branch/items/return", component: BranchItemsReturn},
          { path: "/branch/items/allreturn", component: BranchItemAllReturn},
          { path: "/finished_products/urgent_orders", component: FPUrgentOrders},
          { path: "/items/alltransfers", component: AllItemDirectTransfers },
          { path: "/finished_products/alltransfers", component: AllFPDirectTransfers },
          { path: "/items/alldrafts", component: AllDrafts},
          { path: "/finished_product/generate_po", component: FinishedProductPOGeneration},
          { path: "/finished_product/all_po", component: FinishedProductViewPO},
          { path: "/finished_products/direct_transfer", component: FinishedProductsDirectTransfer },

          // Reports
          { path: "/products/product_arrangement_report", component: ProductArrangementReport},
          { path: "/products/product_category_driver_arrangement_report", component: ProductCategoryDriverArrangementReport},
          { path: "/products/wasted_inventory", component: CentraKitchenFPWastedInventory },

          {
            path: "/products/product_order_report",
            component: ProductOrderReport,
          },
          {
            path: "/finished_products/orders_in_process/dashboard",
            component: FinishedProductOrdersInProcessForDashboard,
          },
          {
            path: "/products/branchwise_product_order_report",
            component: BranchwiseProductOrderReport,
          },
          {
            path: "/products/productwise_order_report",
            component: ProductwiseOrderReport,
          },
          {
            path: "/products/product_sectionwise_order_report",
            component: ProductSectionwiseOrderReport,
          },

          // Branch Functionality
          { path: "/branch_po_requests", component: BranchPORequests_Branch},
          { path: "/branch_requisition_request", component: BranchRequisitionRequest},
          { path: "/branch_all_po", component: BranchAllPO },
          { path: "/finished_products/add_order", component: FinishedProductAddOrder},
          {
            path: "/finished_products/all_orders",
            component: FinishedProductAllOrders,
          },

          {
            path: "/items/add_order",
            component: ItemAddOrder,
          },
          {
            path: "/items/all_orders",
            component: ItemAllOrders,
          },

          { path: "/equipments/add_order", component: BranchEquipmentAddOrder },
          {
            path: "/equipments/all_orders",
            component: BranchEquipmentAllOrder,
          },

          {
            path: "/items/order/from/sub_store",
            component: BranchItemAddOrdersToSubStore,
          },
          {
            path: "/items/allorders/from/sub_store",
            component: BranchItemAllOrdersToSubStore,
          },

          {
            path: "/items/view_branch_inventory",
            component: ItemViewInventory_Branch,
          },
          {
            path: "/branch/equipments_inventory",
            component: BranchEquipmentInventory,
          },

          {
            path: "/items/view_branch_inventory_kitchen",
            component: ItemViewInventory_Branch_Kitchen,
          },
          {
            path: "/items/view_branch_inventory_store",
            component: ItemViewInventory_Branch_Store,
          },
          {
            path: "/items/transfer_inventory",
            component: ItemTransferInventory_Branch,
          },
          {
            path: "/items/transfer_inventory_by_branch",
            component: ItemTransferInventory_ByBranch,
          },
          {
            path: "/closing/items",
            component: BranchItemClosing,
          },
          {
            path: "/closing/finished_products",
            component: BranchFinishedProductClosing,
          },
          {
            path: "/finished_products/view_branch_inventory",
            component: FinishedProductViewInventory_Branch,
          },
          {
            path: "/finished_products/view_branch_inventory_kitchen",
            component: FinishedProductViewInventory_Branch_Kitchen,
          },
          {
            path: "/finished_products/transfer_inventory_by_branch",
            component: FinishedProductTransferInventory_ByBranch,
          },
          {
            path: "/finished_products/transfer_inventory",
            component: FinishedProductTransferInventory,
          },
          {
            path: "/finished_products/view_all_branch_inventory",
            component: FinishedProductViewInventory_AllBranches,
          },
          {
            path: "/items/view_all_branch_inventory",
            component: ItemViewInventory_AllBranches,
          },

          {
            path: "/finished_products/discarded_inventory",
            component: FinishedProductDiscardedInventory_Branch,
          },
          {
            path: "/items/discarded_inventory",
            component: ItemDiscardedInventory_Branch,
          },
          {
            path: "/finished_products/wasted_inventory",
            component: FinishedProductWastedInventory_Branch,
          },
          {
            path: "/items/wasted_inventory",
            component: ItemWastedInventory_Branch,
          },
          {
            path: "/finished_products/expired_inventory",
            component: FinishedProductExpiredInventory_Branch,
          },
          {
            path: "/items/expired_inventory",
            component: ItemExpiredInventory_Branch,
          },
          {
            path: "/items/add_order",
            component: ItemAddOrder,
          },
          {
            path: "/items/all_orders",
            component: ItemAllOrders,
          },
          {
            path: "/items/view_branch_inventory",
            component: ItemViewInventory_Branch,
          },
          {
            path: "/items/view_branch_inventory_kitchen",
            component: ItemViewInventory_Branch_Kitchen,
          },
          {
            path: "/items/expired_inventory",
            component: ItemExpiredInventory_Branch,
          },

          //Equipments Order
          {
            path: "/equipments/add_orders/centralkitchen",
            component: AddEquipOrderByCentral,
          },
          {
            path: "/equipments/all_orders/centralkitchen",
            component: AllEquipOrderByCentral,
          },

          // Procurement
          { path: "/add_requisition", component: AddRequisition },
          { path: "/all_po", component: ViewPO },
          { path: "/add_branches", component: AddBranches },
          { path: "/update_branch", component: UpdateBranches },
          { path: "/products/map_to_all", component: ProductsMapToAll },
          { path: "/branch_products", component: BranchProducts },
          {
            path: "/finished_products/new_orders",
            component: FinishedProductNewOrders,
          },
          {
            path: "/finished_products/orders_in_process",
            component: FinishedProductOrdersInProcess,
          },
          {
            path: "/finished_products/closed_orders",
            component: FinishedProductClosedOrders,
          },
          {
            path: "/finished_products/all_orders_new",
            component: FinishedProductAllOrders_New,
          },

          // Inventory Pages
          {
            path: "/finished_products/update_inventory",
            component: FinishedProductUpdateInventory,
          },
          {
            path: "/finished_products/view_inventory",
            component: FinishedProductViewInventory,
          },
          {
            path: "/finished_products/transfer_inventory",
            component: FinishedProductTransferInventory,
          },
          {
            path: "/finished_products/view_branchwise_inventory",
            component: FinishedProductViewInventory_Branch_ByCentre,
          },
          {
            path: "/equipments/centralkitchen/inventory",
            component: CentralKitchenEquipmentInventory,
          },
          {
            path: "/items/update_inventory",
            component: ItemUpdateInventory,
          },
          {
            path: "/items/view_inventory",
            component: ItemViewInventory,
          },
          {
            path: "/items/used_inventory",
            component: ItemUsedInventory,
          },
          {
            path: "/items/transfer_inventory",
            component: ItemTransferInventory,
          },
          {
            path: "/items/view_branchwise_inventory",
            component: ItemViewInventory_Branch_ByCentre,
          },

          { path: "/all_items", component: AllItems },
          { path: "/item_categories", component: AddItemCategory },
          { path: "/categories-update", component: AllItemCategories },

          { path: "/add_product", component: AddProduct },
          { path: "/add_product_uom", component: AddProductUnits },
          { path: "/all_products", component: AllProducts },
          { path: "/add_product_category", component: AddProductCategory },
          { path: "/product_categories", component: AllProductCategories },

          { path: "/user-changepassword", component: ChangePassword },

          // this route should be at the end of all other routes
          {
            path: "/",
            exact: true,
            component: () => <Redirect to="/dashboard" />,
          },
        ];
      } else if (role == "Branch Supervisor") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/user-changepassword", component: ChangePassword },
          { path: "/notifications", component: Notifications },
          { path: "/branch/items/return", component: BranchItemsReturn},
          { path: "/branch/items/allreturn", component: BranchItemAllReturn},
          { path: "/items/alltransfers", component: AllItemDirectTransfers },
          { path: "/finished_products/alltransfers", component: AllFPDirectTransfers },
          { path: "/branch_requisition_request", component: BranchRequisitionRequest },
          {
            path: "/branch_po_requests",
            component: BranchPORequests_Branch,
          },
          {
            path: "/branch_all_po",
            component: BranchAllPO,
          },
          {
            path: "/finished_products/add_order",
            component: FinishedProductAddOrder,
          },
          {
            path: "/finished_products/all_orders",
            component: FinishedProductAllOrders,
          },

          {
            path: "/items/add_order",
            component: ItemAddOrder,
          },
          {
            path: "/items/all_orders",
            component: ItemAllOrders,
          },
          { path: "/items/alldrafts", component: AllDrafts},
          { path: "/equipments/add_order", component: BranchEquipmentAddOrder },
          { path: "/equipments/all_orders", component: BranchEquipmentAllOrder },

          { path: "/items/order/from/sub_store", component: BranchItemAddOrdersToSubStore },
          { path: "/items/allorders/from/sub_store", component: BranchItemAllOrdersToSubStore },

          {
            path: "/items/view_branch_inventory",
            component: ItemViewInventory_Branch,
          },
          {
            path: "/items/view_branch_inventory_kitchen",
            component: ItemViewInventory_Branch_Kitchen,
          },
          {
            path: "/items/view_branch_inventory_store",
            component: ItemViewInventory_Branch_Store,
          },
          {
            path: "/items/transfer_inventory",
            component: ItemTransferInventory_Branch,
          },
          {
            path: "/items/transfer_inventory_by_branch",
            component: ItemTransferInventory_ByBranch,
          },
          {
            path: "/finished_products/view_branch_inventory",
            component: FinishedProductViewInventory_Branch,
          },
          {
            path: "/finished_products/view_branch_inventory_kitchen",
            component: FinishedProductViewInventory_Branch_Kitchen,
          },
          {
            path: "/finished_products/view_all_branch_inventory",
            component: FinishedProductViewInventory_AllBranches,
          },
          {
            path: "/items/view_all_branch_inventory",
            component: ItemViewInventory_AllBranches,
          },
          { path: "/branch/equipments_inventory", component: BranchEquipmentInventory },
          {
            path: "/finished_products/transfer_inventory",
            component: FinishedProductTransferInventory_Branch,
          },
          {
            path: "/finished_products/transfer_inventory_by_branch",
            component: FinishedProductTransferInventory_ByBranch,
          },
          {
            path: "/closing/items",
            component: BranchItemClosing,
          },
          {
            path: "/closing/finished_products",
            component: BranchFinishedProductClosing,
          },
          {
            path: "/finished_products/discarded_inventory",
            component: FinishedProductDiscardedInventory_Branch,
          },
          {
            path: "/items/discarded_inventory",
            component: ItemDiscardedInventory_Branch,
          },
          {
            path: "/finished_products/wasted_inventory",
            component: FinishedProductWastedInventory_Branch,
          },
          {
            path: "/items/wasted_inventory",
            component: ItemWastedInventory_Branch,
          },
          {
            path: "/finished_products/expired_inventory",
            component: FinishedProductExpiredInventory_Branch,
          },
          {
            path: "/items/expired_inventory",
            component: ItemExpiredInventory_Branch,
          },
          // this route should be at the end of all other routes
          {
            path: "/",
            exact: true,
            component: () => <Redirect to="/dashboard" />,
          },
        ];
      } else if (role == "Main Store Manager" && store_type === "Main Store") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/user-changepassword", component: ChangePassword },
          { path: "/notifications", component: Notifications },

          // Transfers 
          { path: "/items/alltransfers", component: AllItemDirectTransfers },
          { path: "/items/transfer/from/main", component: DirectItemTransferMain },
          { path: "/items/allItemRequests/to_main", component: AllItemRequestsMain },


          // Order 
          { path: "/items/add_new_order/from/main", component: AddNewItemOrderMain },
          { path: "/items/all_orders/to/main", component: AllItemOrdersMain },

          { path: "/equipments/add_orders/mainstore", component: MainStoreEquipmentAddOrder },
          { path: "/equipments/all_orders/mainstore", component: MainStoreEquipmentAllOrder },

          // Procurement
          { path: "/main_store_po_requests", component: MainStorePORequests },
          { path: "/main_store_requisition_request", component: MainStoreRequisitionRequest },
          { path: "/main_store_all_po", component: MainStoreAllPO },


          //Inventory
          { path: "/items/inventory", component: MainStoreItemInventory },
          { path: "/equipments/mainstore/inventory", component: MainStoreEquipmentInventory },


          // this route should be at the end of all other routes
          {
            path: "/",
            exact: true,
            component: () => <Redirect to="/dashboard" />,
          },
        ];
      } else if (role == "Sub Store Manager" && store_type === "Sub Store") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/user-changepassword", component: ChangePassword },
          { path: "/notifications", component: Notifications },
          { path: "/substore/items/return", component: SubStoreItemReturn},
          { path: "/substore/items/allreturn", component: SubStoreItemAllReturn},
      
          // Transfer
          { path: "/items/alltransfers", component: AllItemDirectTransfers },
          { path: "/items/allItemRequests/to_substore", component: AllItemRequestToSubStore },
          { path: "/substore/direct_transfer", component: DirectTransferFromSubStore },

          // Orders
          { path: "/items/add_new_order", component: AddNewItemOrderSubStore },
          { path: "/items/all_orders", component: AllItemsOrdersSubStore },
          { path: "/equipments/add_orders/substore", component: SubStoreEquipmentAddOrder },
          { path: "/equipments/all_orders/substore", component: SubStoreEquipmentAllOrder },

          { path: "/items/ordered/by/branch", component: InProcessOrderByBranch },
          { path: "/substore/deficit_orders", component: DeficitOrder },

          // Inventory
          { path: "/items/substore/inventory", component: SubStoreItemInventory },
          { path: "/equipments/substore/inventory", component: SubStoreEquipmentInventory },

           // Procurement 
           { path: "/sub_store_po_requests", component: SubStorePORequests },
           { path: "/sub_store_requisition_request", component: SubStoreRequisitionRequest },
          { path: "/substore_all_po", component: SubStoreAllPO },


          // this route should be at the end of all other routes
          {
            path: "/",
            exact: true,
            component: () => <Redirect to="/dashboard" />,
          },
        ];
      } else if (role === "Equipment Store Manager") {
        routes = [
          { path: "/dashboard", component: Dashboard },
          { path: "/app_settings", component: AppSettings },
          { path: "/notifications", component: Notifications },

          // Equipment
          { path: "/add_equipment", component: AddEquipment },
          { path: "/update_equipment", component: UpdateEquipments },

           { path: "/update_equipment_category", component:  AllEquipCategories},
          { path: "/add_equipment_category", component:  AddEquipCategory},
          { path: "/add_equipment_unit", component:  AddEquipmentUnits},


          { path: "/add_equipments_supplier", component: AddEquipmentsSupplier },
          { path: "/update_equipments_supplier", component: UpdateEquipmentsSupplier },

          // Inventory
          { path: "/equipments/view_inventory_store", component: EquipmentStoreViewInventory },
          { path: "/equipments/view_branch_inventory", component: EquipmentStoreBranchInventory },
          { path: "/equipments/update_inventory", component: UpdateEquipmentInventory },


          // Orders
          { path: "/equipments/new_orders", component: EquipmentNewOrders },
          { path: "/equipments/orders_in_process", component: EquipmentOrdersInProcess },
          { path: "/equipments/all_orders", component: EquipmentAllOrders },
          { path: "/equipments/closed_orders", component: EquipmentClosedOrders },

          { path: "/user-changepassword", component: ChangePassword },
          // this route should be at the end of all other routes
          { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
        ];
      }
      else {
        routes = [ { path: "/", exact: true, component: () => <Redirect to="/dashboard" />} ];
      }
      response.routes = routes;

      localStorage.setItem("username", response.data.username);
      localStorage.setItem("name", response.data.name);
      localStorage.setItem("store_type", response.data.branch_details.type);
      localStorage.setItem("store_name", response.data.branch_details.name);
      localStorage.setItem("is_manual_entry_allowed", response.data.branch_details.is_manual_entry_allowed);
      localStorage.setItem("is_store", response.data.branch_details.is_store);
      localStorage.setItem("store_id", response.data.branch_details._id);
      localStorage.setItem("transfer_privilege",response.data.branch_details.transfer_privilege);
      localStorage.setItem("mobile", response.data.mobile);
      localStorage.setItem("employee_id", response.data.employee_id);
      localStorage.setItem("role", response.data.role);
      localStorage.setItem("userToken", response.data.token);
      yield put(loginSuccess(response));
      history.push("/dashboard");
    } else {
      yield put(apiError(response.message));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    let url = process.env.REACT_APP_BASEURL + "adminusers/logout";
    const token = localStorage.getItem("userToken");
    if (token) {
      const response = yield call(postSubmitForm, url, {});
      //console.log(response);
      if (response.status === 1) {
        localStorage.clear();
        localStorage.removeItem("username");
        localStorage.removeItem("name");
        localStorage.removeItem("mobile");
        localStorage.removeItem("is_manual_entry_allowed");
        localStorage.removeItem("email");
        localStorage.removeItem("is_store");
        localStorage.removeItem("employee_id");
        localStorage.removeItem("role");
        localStorage.removeItem("userToken");
        history.push("/login");
      }
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* changePassword({ payload: { password_details, history } }) {
  try {
    let url = process.env.REACT_APP_BASEURL + "adminusers/changepassword";

    const response = yield call(postSubmitForm, url, password_details);

    if (response.status === 1) {
      showNotification("Password changed successfully.", "Success");
      yield put(changePasswordSuccess(response));
    } else {
      showNotification(response.message, "Error");
      yield put(apiError(response.message));
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchUserLogin() {
  yield takeEvery(LOGIN_USER, loginUser);
}

export function* watchUserLogout() {
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePassword);
}

function* authSaga() {
  yield all([
    fork(watchUserLogin),
    fork(watchUserLogout),
    fork(watchChangePassword),
  ]);
}

export default authSaga;
